import { Selector, State } from "./types";
import { match } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveUnavailabilitiesRequestFailure(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.request.isFailure : false;
    },
    isRetrieveUnavailabilitiesRequestPending(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.request.isPending : false;
    },
    isRetrieveUnavailabilitiesRequestSuccess(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.request.isSuccessful : false;
    },
    getUnavailabilities(filter) {
      const req = getState().find((req) => match(req.filter, filter));

      return req ? req.unavailabilities : [];
    },
  };
}

export { createSelector };
